const levels = [
  {
    speed: 50,
    brief: [
      {
        subtype: 'calendar',
        title: 'Стратсессия группы компаний «Очень нужные вещи»',
        text: 'в которую входит ваша фабрика. Воспользуйтесь МЭП, чтобы подписывать входящие документы.',
      },
      {
        subtype: 'security',
        title: 'Виктор Семенович Безопасность',
        text:
          'Ваши недоброжелатели внутри компании могут отправлять служебные документы, которые подписывать не нужно!',
      },
    ],

    good: [
      {
        title: 'Договор N 1237/09 от 25.04.2019',
        text: 'на закупку кленового бруса для изготовления деревянных заготовок.',
      },
      {
        title: 'Дополнительное соглашение к договору N23/67',
        text: 'на аренду танкера для доставки продукции в Танзанию.',
      },
      {
        title: 'Спонсорское соглашение о поддержке «Дня Пифагора»',
        text: 'во всех школах страны в День математики.',
      },
      {
        title: 'Договор  N 27/1828',
        text: 'о закупке шоколада в форме египетских пирамид в качестве сувенирной продукции.',
      },
      {
        title: 'Приказ N 37/вн',
        text: 'о выплате ежемесячных премий сотрудникам фабрики.',
        error: 'Увы, вы отклонили важный документ.',
      },
      {
        title: 'Акт выполненных работ N 098',
        text: 'от компании «а2 + b2 = с2»',
      },
      {
        title: 'Договор N 66/61313',
        text: 'о предоставлении кредита банком Ibarelytrust.you.',
      },
      {
        title: 'Протокол собрания N 34 от 10.02.2019',
        text: 'о проблемах с заготовками образцов продукции.',
      },
    ],
    bad: [
      {
        title: 'Договор N 290/ 02',
        text:
          'о закупке оборудования с условием, что лекала станков могут быть любых геометрических форм, без предварительного согласования с покупателем.',
        error:
          'Без уточнения спецификации вам поставили станки для круглых транспортиров, производство на время встало, бизнес понес убытки.',
      },
      {
        title: 'Служебная записка',
        text:
          'об отказе компенсационной выплаты лесорубу Баянову Павлу Никитовичу на основании приказа об увольнении по соглашению сторон.',
        error:
          'Согласно ТК РФ, вы обязаны выплатить необходимую компенсацию сотруднику, увольняющемуся по соглашению сторон.',
      },
      {
        title: 'Уведомление N 2019',
        text: 'об отказе предоставить бухгалтерскую отчетность в органы налоговой службы.',
        error:
          'Если генеральный директор не предоставляет бухгалтерскую отчетность, последствия могут быть самыми плачевными!',
      },
    ],
  },
]

levels[1] = {
  speed: 65,
  brief: [
    {
      subtype: 'calendar',
      title: 'Командировка в Архангельскую область',
      text: 'Инспекция заготовки карельской березы. Воспользуйтесь МЭП, чтобы подписывать входящие документы',
    },
    {
      subtype: 'security',
      title: 'Виктор Семенович Безопасность',
      text: 'Будьте внимательны, недоброжелатели могут подталкивать вас к решениям, причиняющим вред вам или бизнесу',
    },
  ],
  good: [
    {
      title: 'Договор N23/088 от 23.02.2019',
      text: 'на закупку суперклея для склейки треугольных линеек.',
    },
    {
      title: 'Договор N123/890 от 01.02.2019',
      text: 'на поставку 2 000 000 деревянных треугольных линеек Министерству образования республики Вануату.',
    },
    {
      title: 'Лицензия N23/бис 29',
      text: 'на вырубку пирамидального тополя для изготовления сырья.',
    },
    {
      title: 'Договор N3/14159 от 02.03.2019',
      text: 'на оказание консультационных услуг коммуникационным агентством ООО «Пиар в квадрате».',
    },
    {
      title: 'Акт выполненных работ N37 от 12.01.2019',
      text: 'по распилу двутавровых балок б/у.',
    },
    {
      title: 'Акт выполненных работ N007 от 02.02.2019',
      text: 'по оказанию услуг безопасности и сопровождения грузов агентством «Пирамида»',
    },
    {
      title: 'Служебная записка',
      text: 'на оформление командировки в Лесосибирск экспедитора Эвклидова Г. Е.',
    },
    {
      title: 'Служебная записка',
      text: 'о выделении дополнительного выходного дня сторожу Сергееву У.Д.',
    },
    {
      title: 'Акт выполненных работ N2 договора N379',
      text: 'о проведении ремонтных работ в здании фабрики.',
    },
    {
      title: 'Договор N39/12',
      text: 'на изготовление премиальной линейки линеек из черного тика и эбенового дерева.',
    },
    {
      title: 'Договор N1938',
      text: 'о спонсорской поддержке юбилейного переиздания книги Владимира Бибихина «Лес».',
    },
    {
      title: 'Договор N472/09 от 04.02.2019',
      text: 'на закупку 200 кубических метров кедра у ООО «Сосна и ясень».',
    },
  ],
  bad: [
    {
      title: 'Протокол собрания акционеров N 23',
      text: 'об отзыве всей партии деревянных треугольников, изготовленной за 2019 год.',
      error:
        'Вы правда считаете, что подписать такой документ без проверки — хорошая идея? Изъятие продукции повлекло колоссальные убытки и потерю рынка.',
    },
    {
      title: 'Постановление',
      text: 'о раскрытии ноу-хау изготовления прототипов новейшей версии продукции в общее пользование.',
      error:
        'Вот так просто взять и отдать секрет производства легендарных треугольников? Ваши конкуренты с удовольствием взяли его на вооружение.',
    },
    {
      title: 'Соглашение',
      text: 'о продаже 75 % акций компании ООО «Готовальня и циркуль» за 0 рублей.',
      error: 'Нужно внимательнее смотреть, что вы подписываете: вы только что продали компанию конкуренту.',
    },
    {
      title: 'Служебная записка',
      text:
        'от отдела маркетинга на согласование нанесения на продукцию фабрики логотипа, схожего с логотипом компании Koh-i-Noor, в рамках агрессивной маркетинговой кампании.',
      error: 'Вы только что одобрили для компании крупный иск от конкурентов и штраф.',
    },
    {
      title: 'Договор',
      text: 'об оплате услуг компании ООО «Древо жизни» на сумму 200 000 USD.',
      error: 'На территории РФ компании могут осуществлять оплаты услуг только в рублях! Будьте внимательнее.',
    },
  ],
}

levels[2] = {
  speed: 85,
  brief: [
    {
      subtype: 'calendar',
      title: 'Командировка в Гавану (Куба)',
      text:
        'Обсуждение поставок специальной партии треугольников красного цвета. Воспользуйтесь МЭП, чтобы подписывать входящие документы, он работает и за границей!',
    },
    {
      subtype: 'security',
      title: 'Виктор Семенович Безопасность',
      text:
        'Мы вычислили провокаторов, но могут быть и другие. Следите внимательно за тем, какие документы вам попадают на подпись!\n',
    },
  ],
  good: [
    {
      title: 'Дополнительное соглашение N 2 к договору N 20/1 от 20.01.2018',
      text: 'об оказании научно-консультативных услуг Жан Полем де Гуа.',
    },
    {
      title: 'Договор N360/4 от 27.02.2019',
      text: 'о закупке образца 1 см из Всемирной палаты Мер и Весов.',
    },
    {
      title: 'Договор N 4891/09 от 26.01.2019',
      text: 'об аренде двух грузовиков для перевозки бревен.',
    },
    {
      title: 'Договор N 98/027 от 2.03.2019',
      text: 'о закупке пробной партии пластмассы для диверсификации производства.',
    },
    {
      title: 'Договор N300/20 от 20.01.2019',
      text: 'об аренде 20 трелевочных тракторов для дочернего предприятия ООО «Всё ровно».',
    },
    {
      title: 'Ведомость',
      text: 'о начислении зарплаты сотрудникам фабрики ООО «Деревянные треугольные линейки».',
    },
    {
      title: 'Распоряжение',
      text: 'о выговоре работнику ОТК Неумейко В. И. за несоблюдение прямого угла в изделии.',
    },
    {
      title: 'Акт выполненных работ по приложению N 3 договора N 238 от 09.04.2019',
      text: 'о пошиве реквизита к спектаклю «Буратино» на День знаний.',
    },
    {
      title: 'Положение N 34/вн',
      text: 'о введении в штатное расписание предприятия должности «краснодеревщик».',
    },
    {
      title: 'Соглашение',
      text: 'о партнерстве с ООО «Замыкая круг» о совместном производстве циркулей.',
    },
    {
      title: 'Служебная записка',
      text: 'о предоставлении больничного отпуска сверлильщику Дятлову И. В.',
    },
    {
      title: 'Приказ',
      text:
        'о зачислении в штат Тейлора Б. И. на должность «старший научный сотрудник отдела перспективных разработок».',
    },
    {
      title: 'Положение',
      text: 'о соответствии продукции ООО «Деревянные треугольные линейки» нормативам Рособрнадзора.',
    },
    {
      title: 'Положение N 340 от 23.04',
      text: 'о неразглашении концепции новой продукции с углом в 120 градусов.',
    },
    {
      title: 'Договор N 23/5 от 28/077',
      text: 'о закупке 23000 курвиметров для нужд производства.',
    },
  ],
  bad: [
    {
      title: 'Приказ N 298',
      text: 'об увольнении генерального директора ООО «Деревянные треугольные линейки».',
      error:
        'Но генеральный директор ООО «Деревянные треугольные линейки» — это вы! Думаете, уволить себя — это хорошая идея?',
    },
    {
      title: 'Приказ N 230',
      text:
        'о выделении невозвратного кредита в размере 1 000 000 USD заместителю директора ООО «Деревянные треугольные линейки».',
      error:
        'Вы же понимаете, что только что подарили миллион долларов из бюджета предприятия? Что вы скажете на совете директоров?',
    },
    {
      title: 'Приказ N 23/вн',
      text: 'о запрете приема на работу женщин возрастом до 35 лет в связи с рисками частых декретных отпусков.',
      error:
        'То, что вы только что подписали, напрямую противоречит Трудовому кодексу РФ, теперь вы рискуете получить коллективный судебный иск.',
    },
    {
      title: 'Приказ N 34',
      text: 'об отмене выплат за работу в выходные дни в рамках экономии зарплатного фонда.',
      error:
        'Согласно ТК РФ, работа в выходные дни должна оплачиваться сотрудникам в двойном размере, вы рискуете получить судебные иски!',
    },
    {
      title: 'Распоряжение',
      text: 'об одобрении сделки по сбыту в переработку бракованной продукции по цене в 4 раза ниже рыночной.',
      error:
        'Это заведомо убыточная сделка, суд обязал вас компенсировать все расходы, а акционеры не оценили ваши действия.',
    },
    {
      title: 'Приказ',
      text:
        'о зачислении в штат Файруллоева Ибрагима Медхидовича (гражданина Узбекистана, справка ФМС не получена) на должность озеленителя территории завода.',
      error: 'Вы наняли на работу человека без необходимого разрешения. Неудачное решение, неудачное!',
    },
    {
      title: 'Приказ',
      text:
        'об увольнении шлифовальщика Бурова Карла Иосифовича за неподобающее поведение на корпоративном мероприятии.',
      error:
        'Подобное основание не является достаточным для увольнения, вам нужно соблюдать необходимые процедуры, чтобы не попасть под суд.',
    },
  ],
}

export default levels
